// import JobDescriptionA from '../component/job-descriptionA';
import JobDescriptionB from '../components/apply-pages/job-descriptionB';
import JobDescriptionC from '../components/apply-pages/job-descriptionC';
import { JobDescriptionSEO } from '../components/apply-pages/job-descriptionS';

export const applyPageVersions = [
  {
    key: 'B',
    component: JobDescriptionB,
    weight: 0.75,
  },
  {
    key: 'C',
    component: JobDescriptionC,
    weight: 0.25,
  },
  {
    key: 'S',
    component: JobDescriptionSEO,
    weight: 0,
  },
];

const generateWeightedList = () => {
  const weightedList = [];
  applyPageVersions.forEach((version) => {
    const multiples = version.weight * 100;
    for (let i = 0; i < multiples; i += 1) {
      weightedList.push(version);
    }
  });
  return weightedList;
};

export const getRandomApplyPageVariation = () => {
  const weightedList = generateWeightedList();
  const randomNumber = Math.floor(Math.random() * weightedList.length);
  return weightedList[randomNumber];
};
